export default __webpack_public_path__ + "static/TrimSplit-9f679312338d9c81b5863f540fb13f39.png";